
// import React from 'react';
// import Header from "../components/Header";
// import Footer from "../components/Footer";
// import Testimonials from '../components/Coach/Testimonials';
// import HighlightsCreator from '../components/Coach/HighlightsCreator';

// const IOSUrl = "https://apps.apple.com/us/app/hyphii-healthy-lifestyle-app/id6737209270";

// const scrollToHighlights = () => {
//   const highlightsSection = document.getElementById('highlights');
//   if (highlightsSection) {
//     highlightsSection.scrollIntoView({ behavior: 'smooth' });
//   }
// };

// const CreatorsLanding = () => {
//   return (
//     <div className="flex flex-col min-h-screen bg-white">
//       <Header />

//       <div className="text-center mt-8">
//         <button className="mx-auto px-4 py-2 rounded-full border border-gray-200 text-gray-700 text-sm flex items-center justify-center">
//           All-in-one coaching platform
//         </button>
//       </div>

//       <main className="flex-grow px-4 py-8">
//         <div className="max-w-6xl mx-auto text-center">
//           <h1 className="text-6xl sm:text-7xl font-bold mb-6">
//             Spend more time coaching, less time managing.
//           </h1>
          
     
//           <p className="text-xl sm:text-2xl text-gray-700 mb-8 leading-relaxed max-w-3xl mx-auto">
//             Our platform saves you up to 30% of your time on paperwork, scheduling, and client management so you can focus on what you do best: changing lives. Plus, your clients get a beautiful, ultra-fast experience that keeps them coming back.
//           </p>

        

//           <div className="flex items-center gap-4 justify-center mt-8">
//             <a  
//               href="https://calendly.com/hyphii"
//               target="_blank"
//               rel="noopener noreferrer"
//               className="h-16 bg-black text-white border border-gray-200 px-6 rounded-xl hover:bg-gray-800 transition duration-300 font-medium flex items-center justify-center"
//             >
//               Schedule Demo
//             </a>
//             <button
//               onClick={scrollToHighlights}
//               className="h-16 bg-white text-gray-900 border border-gray-200 px-6 rounded-xl hover:bg-gray-50 transition duration-300 font-medium flex items-center justify-center"
//             >
//               Coach Features
//             </button>
//           </div>
          
//           <p className="mt-6 text-sm text-gray-500 italic">
//             "Transform your passion for wellness into a thriving digital business"
//           </p>

//           <div className="flex flex-col items-center mt-12">
//             <div className="flex mb-2">
//               <div className="flex -space-x-2">
//                 {[1, 2, 3, 4, 5].map((i) => (
//                   <div key={i} className="w-10 h-10 rounded-full bg-gray-300 border-2 border-white overflow-hidden">
//                     <img 
//                       src={`avatar${i}.png`} 
//                       alt="User avatar" 
//                       className="w-full h-full object-cover"
//                     />
//                   </div>
//                 ))}
//               </div>
//             </div>
            
//             <div className="flex text-yellow-400 mb-1">
//               <span>★★★★★</span>
//             </div>
            
//             <p className="text-gray-700">Trusted by the best</p>
//           </div>
//         </div>
        
//        <div className="mt-16 w-full">
//           <img
//             src="coach2.png"
//             alt="Health and Wellness Creator Platform"
//             className="w-full h-auto"
//           />
//         </div>
//       </main>

//       <HighlightsCreator />
//       <Testimonials />
//       <Footer />
//     </div>
//   );
// };

// export default CreatorsLanding;


// //v2

// import React from 'react';
// import Header from "../components/Header";
// import Footer from "../components/Footer";
// import Testimonials from '../components/Coach/Testimonials';
// import HighlightsCreator from '../components/Coach/HighlightsCreator';
// import HeroSection from '../components/Coach/HeroSection';
// import SolutionsSection from '../components/Coach/SolutionsSection';

// const CreatorsLanding = () => {
//   return (
//     <div className="flex flex-col min-h-screen bg-white">
//       <Header />
//       <main className="flex-grow">
//         <HeroSection />
//         <HighlightsCreator />
//         <SolutionsSection />
//         <Testimonials />
        
//         {/* CTA Section */}
//         <section className="py-16 bg-emerald-50">
//           <div className="max-w-4xl mx-auto px-4 text-center">
//             <h2 className="text-3xl font-bold mb-6">Ready to transform your coaching business?</h2>
//             <p className="text-lg text-gray-700 mb-8">Join the growing community of coaches who are saving time, increasing client retention, and growing their businesses with our AI-powered platform.</p>
            
//             <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
//               <a 
//                 href="https://calendly.com/hyphii" 
//                 target="_blank"
//                 rel="noopener noreferrer"
//                 className="w-full sm:w-auto bg-black text-white px-8 py-4 rounded-xl hover:bg-emerald-600 transition duration-300 font-medium flex items-center justify-center"
//               >
//                 Schedule Demo
//               </a>
//               <a 
//                 href="#features"
//                 className="w-full sm:w-auto bg-white text-gray-900 border border-gray-200 px-8 py-4 rounded-xl hover:bg-gray-50 transition duration-300 font-medium flex items-center justify-center"
//               >
//                 Learn More
//               </a>
//             </div>
//           </div>
//         </section>
        
//         {/* Features Grid */}
//         <section className="py-16 bg-white">
//           <div className="max-w-6xl mx-auto px-4">
//             <div className="grid md:grid-cols-3 gap-6">
//               <div className="p-6 border border-gray-100 rounded-xl hover:shadow-md transition duration-300">
//                 <h3 className="text-xl font-semibold mb-3">Targeted to Solopreneurs</h3>
//                 <p className="text-gray-600">Built exclusively for coaching and wellness professionals with industry-specific templates and workflows.</p>
//               </div>
//               <div className="p-6 border border-gray-100 rounded-xl hover:shadow-md transition duration-300">
//                 <h3 className="text-xl font-semibold mb-3">True AI Differentiation</h3>
//                 <p className="text-gray-600">Not just automations—our platform learns user behavior and client preferences for personalized recommendations.</p>
//               </div>
//               <div className="p-6 border border-gray-100 rounded-xl hover:shadow-md transition duration-300">
//                 <h3 className="text-xl font-semibold mb-3">Frictionless Experience</h3>
//                 <p className="text-gray-600">Minimal setup with calendar, payment, and email integrations for instant improvement in efficiency.</p>
//               </div>
//             </div>
//           </div>
//         </section>
//       </main>
//       <Footer />
//     </div>
//   );
// };

// export default CreatorsLanding;
import React from 'react';
import Header from "../components/Header";
import Footer from "../components/Footer";
import HeroSection from '../components/Coach/HeroSection';
import TabbedFeaturesSection from '../components/Coach/TabbedFeaturesSection';
import Testimonials from '../components/Coach/Testimonials';
import SolutionsSection from '../components/Coach/SolutionsSection';
import GuaranteeSection from '../components/Coach/GuaranteeSection';
import StoryAndCTA from '../components/Coach/StoryAndCTA';
import WhyKinosDifferent from '../components/Coach/WhyKinosDifferent';

const CreatorsLanding = () => {
  return (
    <div className="flex flex-col min-h-screen bg-white">
      <Header />
      <main className="flex-grow">
        {/* Hero Section with clear value proposition */}
        <HeroSection />
        
        {/* Features Section */}
        <TabbedFeaturesSection />
        
        {/* Why KinOS is Different section */}
        <WhyKinosDifferent />
        
        {/* Problem/Solution Section */}
        {/* <SolutionsSection /> */}
        
        {/* Testimonials Section - visual proof */}
        
        {/* Guarantee Section */}
        <GuaranteeSection />
        <Testimonials />

        
        {/* Storytelling Section & Final CTA */}
        <StoryAndCTA />
      </main>
      <Footer />
    </div>
  );
};

export default CreatorsLanding;